<template>
    <div class="countries-update-modal">
        <ModalContainer :title="$t('countries.edit_country')" identifier="countries-update-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_saving || is_loading_country">
                <FormInputText v-model="$v.country.code.$model" identifier="code" :label="$t('countries.code')"
                               :disabled="is_saving || is_loading_country"
                               :has-error="$v.country.code.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.country.code.required">
                            {{$t('validation.x_is_required',{x: $t('countries.code')})}}
                        </p>
                    </template>
                </FormInputText>

                <FormInputText v-model="$v.country.name.$model" identifier="name" :label="$t('countries.name')"
                               :disabled="is_saving || is_loading_country"
                               :has-error="$v.country.name.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.country.name.required">
                            {{$t('validation.x_is_required',{x: $t('countries.name')})}}
                        </p>
                    </template>
                </FormInputText>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('save')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
import _ from 'lodash';
import ModalContainer from "../modal/ModalContainer";
import Form from "../form/Form";
import FormInputText from "../form/FormInputText";
import FormGroupTwo from "../form/FormGroupTwo";
import FormInputSelect from "../form/FormInputSelect";
import {required, email} from 'vuelidate/lib/validators'
import Button from "../Button";
import FormInputPassword from "@/components/form/FormInputPassword";

export default {
    name: "CountriesUpdateModal",
    components: {FormInputPassword, Button, FormInputSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
    props: {
        country_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            country: {
                code: null,
                name: null,
            },
            is_saving: false,
            is_loading_country: true,
        }
    },
    validations: {
        country: {
            code: {required},
            name: {required},
        }
    },
    methods: {
        close(status) {
            this.$modal.hide('countries-update-modal', status);
        },
        save() {
            this.$v.country.$touch();
            if (this.$v.country.$anyError || this.is_saving)
                return;

            this.is_saving = true;

            let payload = {
                code: this.$v.country.code.$model,
                name: this.$v.country.name.$model
            };

            this.$axios.patch(`countries/${this.country_id}`, payload).then(({data}) => {
                this.$notify({
                    text: this.$t('countries.success_updated'),
                    type: 'success',
                });

                this.is_saving = false;
                this.close(true);
            }).catch(e => {
                this.is_saving = false;

                this.$notify({
                    title: this.$t('error'),
                    text: this.$larerror(e.response.data.errors, this.$t('countries.error_update')),
                    type: 'error',
                });
            });
        },
        async getCountry() {
            this.is_loading_country = true;

            await this.$axios.get(`countries/${this.country_id}`)
                .then(({data}) => {
                    this.$v.country.code.$model = data.data.attributes.code;
                    this.$v.country.name.$model = data.data.attributes.name;

                    this.is_loading_country = false;
                })
                .catch(e => {
                    this.is_loading_country = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data, this.$t('countries.error_retrieve')),
                        type: 'error',
                    });
                });
        },
    },
    mounted() {
        this.getCountry();
    }
}
</script>
